import { useEffect, useState } from 'react';
import { getPlatformTelemetry } from '../api/client';
import type { PlatformTelemetry } from '../types';

export function usePlatformTelemetry() {
  const [data, setData] = useState<PlatformTelemetry | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getPlatformTelemetry()
      .then(setData)
      .catch((e: Error) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  return { data, loading, error };
}
